const TEAM_PULSE_LEADER_ROLES = new Set(["Admin", "Manager"]);

/**
 * Team Pulse is available to everyone unless the customer's backend flag is
 * explicitly disabled. A disabled flag restricts the dashboard to leaders.
 */
export const canViewTeamPulse = (user: any): boolean => {
    if (user?.customer?.showTeamPulse !== false) return true;

    return TEAM_PULSE_LEADER_ROLES.has(user?.role?.name);
};
